import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getTargetOpportunities } from "../api/heat-map.api";
import type { TargetOpportunityModel } from "../types/TargetOppotunity";
import type { DashboardFilterPayload } from "../utils/heat-map.utils";

export const useTargetOpportunities = (payload: DashboardFilterPayload) => {
  const [data, setData] = useState<TargetOpportunityModel[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { run: runLatestRequest, loading } = useLatestRequest();

  const fetchData = useCallback(async () => {
    try {
      setError(null);
      const result = await runLatestRequest((signal) => getTargetOpportunities(payload, signal));

      if (!result) return undefined;

      setData(result);
      return result;
    } catch (fetchError) {
      setData(null);
      setError(getApiErrorMessage(fetchError, "Failed to load target opportunities"));
      return undefined;
    }
  }, [payload, runLatestRequest]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
